import React, { useState, useRef, useEffect, useCallback } from "react";
import { models } from 'powerbi-client';
import { PowerBIEmbed } from 'powerbi-client-react';
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import Fab from '@material-ui/core/Fab';
//import {Tooltip, Button} from '@material-ui/core';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
//import { toolbarheight } from '../../theme';
import { loadEmbedInfoForReport, clearEmbedInfo } from "../../redux/embeddedpbireports/actions";
import { addSignOutCallback } from "../../redux/authentication/actions";
import { makeStyles } from '@material-ui/core/styles';
import "./EmbeddedPbiReports.css";


const useStyles = makeStyles((theme) => ({
	container: {
		position: 'relative',
        display: 'flex',
		flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
		//'&:hover $fab': {
		//	visibility: (props) => (props.visible ? 'visible' : 'hidden'),
		//}
	},
	fab: {
		position: 'absolute',
        visibility: (props) => (props.visible ? 'visible' : 'hidden'),
		backgroundColor: `rgba(38,47,62,0.75)`,
		color: 'white',
		top: '7px',
        '&:hover': {
			backgroundColor: `rgba(38,47,62,0.9)`, // Keep the same background color on hover
		},
        transition: 'opacity 0.9s ease-in-out'
	}
}));

const PbiReportPage = (props) => {
	const [visible, setVisible] = useState(false);
    const timerRef = useRef(null);
    const classes = useStyles({ visible });
	const { workspaceId, reportId, reportName } = props;
    const { t } = useTranslation();
	const embedInfo = useSelector((state) => state.embedInfo);
    const dispatch = useDispatch();
    // PowerBI Report object (to be received via callback)
	const [report, setReport] = useState();
    // Report config useState hook
	// Values for properties like embedUrl, accessToken and settings will be set on click of buttons below
	const [reportConfig, setReportConfig] = useState({
		type: 'report',
		id: undefined,
		embedUrl: undefined,
		tokenType: models.TokenType.Embed,
		permissions: models.Permissions.All,
		accessToken: undefined,
		settings: undefined,
		contrastMode: models.ContrastMode.None
	});

	// Map of event handlers to be applied to the embedding report
	const eventHandlersMap = new Map([
		['loaded', function () {
            console.log('Report has loaded');
		}],
		['rendered', function () {
			console.log('Report has rendered');
		}],
		['error', function (event) {
			if (event) {
				console.error('error', event.detail);
			}
		}]
	]);

    useEffect(() => {
        const handleKeyDown = (event) => {
			if (event.key === 'f' && event.ctrlKey && event.altKey) {
				setVisible((prevState) => !prevState);
                timerRef.current = setTimeout(() => {
                    setVisible(false);
                }, 3000);
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

	useEffect(() => {
		if (!embedInfo.isLoading) {
            dispatch(clearEmbedInfo());
			dispatch(loadEmbedInfoForReport(workspaceId, reportId));
		}
	}, [dispatch, reportId]);

	useEffect(() => {
		setReportConfig({
			...reportConfig,
			id: embedInfo.embedPbiInfo.embedReport.length != 0 ? embedInfo.embedPbiInfo.embedReport[0].reportId : undefined,
			embedUrl: embedInfo.embedPbiInfo.embedReport.length != 0 ? embedInfo.embedPbiInfo.embedReport[0].embedUrl : undefined,
			accessToken: embedInfo.embedPbiInfo.embedToken.token,
			settings: {
				panes: {
					filters: { visible: true },
					pageNavigation: { visible: true, position: models.PageNavigationPosition.Left }
				}
            }
		});
	}, [embedInfo]);

    const clear = useCallback(() => {
            dispatch(clearEmbedInfo());
        }, [dispatch]);

    addSignOutCallback(clear);

    const handleMouseEnter = () => {
		clearTimeout(timerRef.current);
        setVisible(true);
        timerRef.current = setTimeout(() => {
            setVisible(false);
        }, 3000);

    };

    const handleMouseLeave = () => {
        timerRef.current = setTimeout(() => {
            setVisible(false);
        }, 3000); // Change this value to adjust the delay before the FAB disappears
    };

	const handleClick = () => {
        report?.fullscreen();
        clearTimeout(timerRef.current);
		setVisible(false);

    };

	return (
		<div className={classes.container}
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
		>
			<Fab aria-label="fullscreen" onClick={handleClick} className={classes.fab} >
				<FullscreenIcon />
			</Fab>

            <PowerBIEmbed
				embedConfig={reportConfig}
				eventHandlers={eventHandlersMap}
				cssClassName={"report-style-class"}
				getEmbeddedComponent={(embedObject) => {
					console.log(`Embedded object of type "${embedObject.embedtype}" received`);
					setReport(embedObject);
				}}
			/>
        </div>
	);
};

export default PbiReportPage;
